// parse disclaimer text and swap out any markdown links [text](href)
// throw everything in an array to be rendered
const convertMarkdownLinks = (
  textToParse: string,
  textTransformFn: (someText:string) => any,
  linkTransformFn: (linkText: string, linkHref: string) => any
) => {
  let markdownToRender: any[] = []
  let textToEvaluate: string = textToParse
  let markdownLinkRegex: RegExp | null = null
  let parsedString: string[] | RegExpExecArray | null = []
  const resetAndExecuteRegex = () => {
    markdownLinkRegex = RegExp(/\[(.*?)\]\((.+?)\)/, 'g')
    parsedString = markdownLinkRegex.exec(textToEvaluate)
  }
  resetAndExecuteRegex()
  while (parsedString !== null) {
    const splitText = [
      textToEvaluate.substring(0, textToEvaluate.indexOf(parsedString[0])),
      textToEvaluate.substring(textToEvaluate.indexOf(parsedString[0])+parsedString[0].length)
    ]
    markdownToRender.push(textTransformFn(splitText[0]))
    markdownToRender.push(linkTransformFn(parsedString[2], parsedString[1]))
    textToEvaluate = splitText[1]
    resetAndExecuteRegex()
  }
  markdownToRender.push(textTransformFn(textToEvaluate))
  return markdownToRender
}

export default convertMarkdownLinks
